import { forwardRef, type Ref, type SVGProps } from "react";
const IconFilePDFOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 13h-1V9.84a2 2 0 0 0-.58-1.41l-5.83-5.84A2 2 0 0 0 19.18 2H7a2 2 0 0 0-2 2v9H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-2h1a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2m-8-8.17L24.16 9H20zM7 4h11v5a2 2 0 0 0 2 2h5v2H7zm18 24H7v-2h18zm3-4H4v-9h24z" />
    <path d="M16.2 16.83h-2.1v5.34h2.1c1.64 0 2.41-1 2.41-2.69s-.75-2.65-2.41-2.65m-.2 4.31h-.6v-3.28h.6c1 0 1.29.71 1.29 1.65-.01 1.32-.55 1.63-1.29 1.63m-5.44-4.31H8.31v5.34h1.28v-1.65h.95a1.75 1.75 0 0 0 1.89-1.84 1.76 1.76 0 0 0-1.87-1.85m-.45 2.71h-.52v-1.71h.67a.78.78 0 0 1 .86.85c0 .63-.39.86-1.01.86m13.82-1.67h-2.26v1.28h2.06v1.01h-2.06v2h-1.29v-5.33h3.55z" />
  </svg>
);
const ForwardRef = forwardRef(IconFilePDFOutlineSVG);
ForwardRef.displayName = "IconFilePDFOutline";
export { ForwardRef as IconFilePDFOutline };
